import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { PopoverController } from "@ionic/angular";

/** One entry of {@link PopoverActionMenuComponent} */
export interface ActionMenuItem<T = any> {
  /** Ionicons name */
  icon: string;
  text: string;
  /** Returned as `data.action` when the entry is chosen */
  action: T;
  /** Destructive entry (e.g. delete): shown last, in red, after a separator */
  danger?: boolean;
}

/**
 * Generic menu of actions, opened as a popover anchored to the button that triggered it.
 * Dismisses with `{ action }` of the chosen entry (nothing when closed by tapping outside).
 */
@Component({
    selector: "app-popover-action-menu",
    templateUrl: "./popover-action-menu.component.html",
    styleUrls: ["./popover-action-menu.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopoverActionMenuComponent {
  @Input() actions: Array<ActionMenuItem> = [];

  constructor(private _popoverController: PopoverController) {}

  /** Regular entries first, destructive ones at the bottom */
  public get regularActions(): Array<ActionMenuItem> {
    return this.actions.filter((item) => !item.danger);
  }

  public get dangerActions(): Array<ActionMenuItem> {
    return this.actions.filter((item) => item.danger);
  }

  public onClickAction(item: ActionMenuItem): void {
    this._popoverController.dismiss({ action: item.action });
  }
}
